<ng-container *ngFor="let row of rows">
    <div class="row">
        <ng-container *ngFor="let panel of row; let last = last, let first = first" [ngSwitch]="panel.type">
            <lm-twelve-column-panel-list #card
                                     *ngSwitchCase="'list'"
                                     [ngClass]="{'last-child': last, 'first-child': first}"
                                     [panel]="panel"
                                     [fromDataView]="fromDataView"
                                     [messageRuleView]="messageRuleView"
                                     (componentDisplayed)="onComponentDisplayed()"
                                     (contentModified)="onContentModified($event)"
                                     (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                                     (panelTransactionEvent)="onPanelTransactionEvent($event)"
                                     (drillAroundEvent)="onDrillAroundEvent($event)"
            ></lm-twelve-column-panel-list>

            <lm-twelve-column-panel-list #card
                                     *ngSwitchCase="'formlist'"
                                     [ngClass]="{'last-child': last, 'first-child': first}"
                                     [panel]="panel"
                                     [fromDataView]="fromDataView"
                                     [messageRuleView]="messageRuleView"
                                     (componentDisplayed)="onComponentDisplayed()"
                                     (contentModified)="onContentModified($event)"
                                     (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                                     (panelTransactionEvent)="onPanelTransactionEvent($event)"
                                     (drillAroundEvent)="onDrillAroundEvent($event)"
            ></lm-twelve-column-panel-list>

            <lm-twelve-column-panel-form #card
                                     *ngSwitchCase="'standardform'"
                                     [ngClass]="{'last-child': last, 'first-child': first}"
                                     [panel]="panel"
                                     [formUrlInfo]="formUrlInfo"
                                     [fromDataView]="fromDataView"
                                     [messageRuleView]="messageRuleView"
                                     (componentDisplayed)="onComponentDisplayed()"
                                     (fieldEvent)="onFieldEvent($event)"
            ></lm-twelve-column-panel-form>

            <lm-twelve-column-panel-form #card
                                     *ngSwitchCase="'form'"
                                     [ngClass]="{'last-child': last, 'first-child': first}"
                                     [panel]="panel"
                                     [formUrlInfo]="formUrlInfo"
                                     [fromDataView]="fromDataView"
                                     [messageRuleView]="messageRuleView"
                                     [model]="model"
                                     [placeHolder]="placeHolder"
                                     [specFields]="specFields"
                                     (componentDisplayed)="onComponentDisplayed()"
                                     (fieldEvent)="onFieldEvent($event)"
            ></lm-twelve-column-panel-form>

            <lm-twelve-column-panel-form #card
                                     *ngSwitchCase="'independentform'"
                                     [ngClass]="{'last-child': last, 'first-child': first}"
                                     [panel]="panel"
                                     [fromDataView]="fromDataView"
                                     [messageRuleView]="messageRuleView"
                                     (componentDisplayed)="onComponentDisplayed()"
            ></lm-twelve-column-panel-form>

            <lm-twelve-column-panel-form-template #card
                                              *ngSwitchCase="'templateform'"
                                              [ngClass]="{'last-child': last, 'first-child': first}"
                                              [panel]="panel"
                                              [fromDataView]="fromDataView"
                                              [messageRuleView]="messageRuleView"
                                              [model]="model"
                                              [placeHolder]="placeHolder"
                                              [specFields]="specFields"
                                              (componentDisplayed)="onComponentDisplayed()"
            ></lm-twelve-column-panel-form-template>

            <lm-twelve-column-panel-form #card
                 *ngSwitchCase="'instancecountchart'"
                 [ngClass]="{'last-child': last, 'first-child': first}"
                 [panel]="panel"
                 [fromDataView]="fromDataView"
                 [messageRuleView]="messageRuleView"
                 (componentDisplayed)="onComponentDisplayed()"
                 (fieldEvent)="onFieldEvent($event)"
            ></lm-twelve-column-panel-form>

            <lm-twelve-column-panel-card #card
                    *ngSwitchCase="'cardview'"
                    [ngClass]="{'last-child': last, 'first-child': first}"
                    [panel]="panel"
                    [fromDataView]="fromDataView"
                    [messageRuleView]="messageRuleView"
                    (uiLinkEvent)="onUILinkEvent($event)"
            ></lm-twelve-column-panel-card>

            <lm-twelve-column-panel-form #card
                    *ngSwitchCase="'menuPanel'"
                    [ngClass]="{'last-child': last, 'first-child': first}"
                    [panel]="panel"
                    [fromDataView]="messageRuleView"
                    [messageRuleView]="messageRuleView"
                    (componentDisplayed)="onComponentDisplayed()"
                    (fieldEvent)="onFieldEvent($event)"
            ></lm-twelve-column-panel-form>

            <lm-twelve-column-panel-form #card
                    *ngSwitchCase="'MenuLinkBoxPanel'"
                    [ngClass]="{'last-child': last, 'first-child': first}"
                    [panel]="panel"
                    [fromDataView]="messageRuleView"
                    [messageRuleView]="messageRuleView"
                    (componentDisplayed)="onComponentDisplayed()"
                    (fieldEvent)="onFieldEvent($event)"
            ></lm-twelve-column-panel-form>

            <lm-twelve-column-panel-url #card
                    *ngSwitchCase="'url'"
                    [ngClass]="{'last-child': last, 'first-child': first}"
                    [panel]="panel"
                    [fromDataView]="fromDataView"
                    [messageRuleView]="messageRuleView"
                    (uiLinkEvent)="onUILinkEvent($event)"
                    (panelTransactionEvent)="onPanelTransactionEvent($event)"
            ></lm-twelve-column-panel-url>

            <lm-twelve-column-panel-url #card
                    *ngSwitchCase="'link'"
                    [ngClass]="{'last-child': last, 'first-child': first}"
                    [panel]="panel"
                    [fromDataView]="fromDataView"
                    [messageRuleView]="messageRuleView"
                    (uiLinkEvent)="onUILinkEvent($event)"
                    (panelTransactionEvent)="onPanelTransactionEvent($event)"
            ></lm-twelve-column-panel-url>

        </ng-container>
    </div>
</ng-container>
